import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = ["canvas", "input", "submit"]

  connect() {
    this.boundResize = this.resize.bind(this)
    this.boundEndStroke = this.onEnd.bind(this)

    this.signaturePad = new SignaturePad(this.canvasTarget)
    this.signaturePad.addEventListener("endStroke", this.boundEndStroke)

    window.addEventListener("resize", this.boundResize)
    this.resize()
    this.syncSubmitState()
  }

  disconnect() {
    this.signaturePad?.removeEventListener("endStroke", this.boundEndStroke)
    window.removeEventListener("resize", this.boundResize)
  }

  clear() {
    this.signaturePad.clear()
    this.inputTarget.value = ""
    this.syncSubmitState()
  }

  onEnd() {
    this.inputTarget.value = this.signaturePad.toDataURL("image/svg+xml")
    this.syncSubmitState()
  }

  resize() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    const value = this.inputTarget.value

    this.canvasTarget.width = this.canvasTarget.offsetWidth * ratio
    this.canvasTarget.height = this.canvasTarget.offsetHeight * ratio
    this.canvasTarget.getContext("2d").scale(ratio, ratio)

    this.signaturePad.clear()
    if (value) {
      this.signaturePad.fromDataURL(value)
    }

    this.syncSubmitState()
  }

  closeModal() {
    this.element.closest("dialog")?.close()
  }

  syncSubmitState() {
    if (!this.hasSubmitTarget) return

    this.submitTarget.disabled = this.signaturePad.isEmpty()
  }
}
